import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField, Collapse } from "@material-ui/core";
import Edit from "assets/icon/edit-icon.svg";
import EditDisable from "assets/icon/EditDisable.svg";
import close from "assets/icon/delete-icon.svg";
import CloseDisable from "assets/icon/CloseDisable.svg";
import * as hirarkiAction from "redux/actions/hirarki";
import { modalToggle, modalToggleReset } from "redux/actions/general";
import HirarkiItemSub from "./HirarkiItemSub";
import HirarkiResult from "./HirarkiResult";
import { isEmpty, toPlainObject } from "lodash";
import _ from "lodash";
export default function HirarkiItem(props) {
  let { classes, is_edited, is_verify, } = props;
  const dispatch = useDispatch();
  const [tugasUtamaModal, settugasUtamaModal] = useState({});
  const [detailTugasUtamaModal, setDetailTugasUtamaModal] = useState({});
  const [urutanProsesModal, seturutanProsesModal] = useState({});
  const [collapse1, setcollapse1] = useState({});
  const [collapse2, setcollapse2] = useState({});
  const [modaltitle, setmodaltitle] = useState("");
  const [test, settest] = useState(0);
  const hirarki = useSelector((state) => state.hirarki);
  const proyek = useSelector((state) => state.proyek);
  const [checked, setChecked] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [showData, setShowData] = useState(true);
  const [showVideo, setShowVideo] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [history, setHistory] = useState([]); // Store the history of `hirarki_wla`
  const [canUndo, setCanUndo] = useState(false);
  const [isError, setIsError] = useState(localStorage.getItem('error') === 'true');
  const [isErrorPegawai, setIsErrorPegawai] = useState(localStorage.getItem('errorPegawai') === 'true');
  let { hirarki_wla, periode, type } = hirarki;
  console.log("hirarki", hirarki_wla);
  useEffect(() => {
    setHirarkiWlaConfig();
  }, [hirarki_wla]);
  const refreshError = () => {
    const errorStatus = localStorage.getItem('error');
    setIsError(errorStatus === 'true');
    const errorPegawaiStatus = localStorage.getItem('errorPegawai');
    setIsErrorPegawai(errorPegawaiStatus === 'true');
  };

  // Example: Refresh error every second
  useEffect(() => {
    const interval = setInterval(() => {
      refreshError();
    }, 500); // check every 500ms

    return () => clearInterval(interval);
  }, []);
  const setHirarkiWlaConfig = async () => {
    // console.log('trigger',hirarki_wla)

    // let res
    // if(!isEmpty(props.tasks)){
    //     if(props.hirarki_id===1){
    //         res =await dispatch(hirarkiAction.setConfigHirarkiIfTaskNotEmptyAndId1(props.tasks))
    //     }else{

    //         res=await dispatch(hirarkiAction.setConfigHirarkiIfTaskNotEmptyAndId2(props.tasks))
    //     }
    // }else{
    //     if(props.hirarki_id===1){
    //         res=await dispatch(hirarkiAction.setConfigHirarkiIfTaskEmptyAndId1())
    //     }else{
    //         res=await dispatch(hirarkiAction.setConfigHirarkiIfTaskEmptyAndId2())
    //     }
    // }
    configCollapseFirstReload();
  };
  const addHistory = (currentState) => {
    setHistory((prevHistory) => [...prevHistory, JSON.parse(JSON.stringify(currentState))]); // Save a deep copy
    setCanUndo(true); // Enable undo
  };
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked); // Update local state
    if (props.onCheckboxChange) {
      props.onCheckboxChange(e.target.checked); // Call parent handler if provided
    }
  };
  const handleNextVideo = () => {
    setShowData(false)
    props.onSave(false)
    setShowVideo(true)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleNext = () => {
    if (currentIndex < hirarki_wla.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setShowData(true);
      props.onSave(false);
    } else {
      setShowResult(true);
      props.onSave(true);
    }

    // Reset undo history when moving to the next item
    setHistory([]); // Clear the history
    setCanUndo(false); // Disable undo
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrevious = () => {
    setCurrentIndex(currentIndex - 1);
    props.onSave(false)
    if (currentIndex === 0) {
      setShowData(false)
    }
    if (currentIndex > -1) {
      setCurrentIndex(currentIndex - 1);
    }
    setHistory([]); // Clear the history
    setCanUndo(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handlePreviousVideo = () => {
    setShowData(true)
    setShowVideo(false)
    props.onSave(false)
    setHistory([]); // Clear the history
    setCanUndo(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const handlePanduan = () => {
    setShowData(true)
    setShowVideo(false)
    setCurrentIndex(-1)
    setShowResult(false)
    setHistory([]); // Clear the history
    setCanUndo(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const handleReviewJob = () => {
    setShowData(false)
    setCurrentIndex(-1)
    setShowResult(false)
    props.onSave(false)
    setHistory([]); // Clear the history
    setCanUndo(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const handleAbk = () => {
    setCurrentIndex(0)
    setShowResult(false)
    props.onSave(false)
    setHistory([]); // Clear the history
    setCanUndo(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const handlePreviousFirst = () => {
    setShowResult(false)
    props.onSave(false)
    setHistory([]); // Clear the history
    setCanUndo(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const configCollapseFirstReload = () => {
    let new_coll = [];
    hirarki_wla.map((data) => {
      data.child.map((child1, i) => {
        child1.child.map((child2, i2) => {
          // if(i2===0){
          new_coll.push({ key: child2.uuid, value: true });
          // }
        });
        // if(i===0){
        new_coll.push({ key: child1.uuid, value: true });

        // }
      });
    });
    let objcoll = _.chain(new_coll).keyBy("key").mapValues("value").value();
    setcollapse1(objcoll);
  };
  // console.log(`collapse1`, collapse1)
  const renderMarginSub = (sub) => {
    if (sub === 1) {
      return 0;
    } else if (sub === 2) {
      return 35;
    } else if (sub === 3) {
      return 40;
    }
  };
  const setcollapse = (hirarkiIndex1, hirarkiIndex2, hirarkiIndex3) => {
    if (hirarkiIndex3 == undefined) {
      hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].collapse =
        !hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].collapse;
    } else {
      hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].child[
        hirarkiIndex3
      ].collapse =
        !hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].child[hirarkiIndex3]
          .collapse;
    }
    dispatch(hirarkiAction.setHirarki(hirarki_wla));
  };
  const onSaveDeskripsiTugasUtama = (hirarkiIndex1) => {
    addHistory(hirarki_wla); // Save current state to history

    const updatedTasks = [...hirarki_wla];
    updatedTasks[hirarkiIndex1].title = modaltitle;
    dispatch(hirarkiAction.setHirarki(updatedTasks));
    showTugasUtamaModal({}, "");
  };
  const undo = () => {
    if (history.length > 0) {
      const lastState = history[history.length - 1]; // Get the last saved state
      setHistory((prevHistory) => prevHistory.slice(0, -1)); // Remove last entry from history
      setCanUndo(history.length > 1); // Check if undo should still be enabled

      dispatch(hirarkiAction.setHirarki(lastState)); // Restore the previous state
    }
  };
  const onSaveDetailDeskripsiTugasUtama = (hirarkiIndex1, hirarkiIndex2) => {
    // Save current state before making changes for undo/redo functionality
    addHistory(hirarki_wla);

    // Update the title of the specific task
    hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].title = modaltitle;

    // Dispatch the updated state to the store
    dispatch(hirarkiAction.setHirarki(hirarki_wla));

    // Close the modal or perform any further actions
    showDetailAktivitasModal({}, "");
  };

  const onSaveUrutanProssess = (hirarkiIndex1, hirarkiIndex2, hirarkiIndex3) => {
    // Save the current state before making changes to allow undo/redo functionality
    addHistory(hirarki_wla);

    // Update the title at the specified nested index
    hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].child[hirarkiIndex3].title = modaltitle;

    // Dispatch the updated state to the store
    dispatch(hirarkiAction.setHirarki(hirarki_wla));

    // Close the modal
    showUrutanProsess({}, "");
  };

  const tambahTugasUtama = async () => {
    // Save the current state before adding a new task
    addHistory(hirarki_wla); // This saves the previous state

    // Create a new task based on the structure of hirarki_wla[0]
    const newTask = {
      ...hirarki_wla[0], // Copy fields if needed, or set defaults
    };

    // Ensure only one task is added (we are adding one task here)
    const updatedTasks = [...hirarki_wla]; // Only one new task is added

    // Dispatch the updated tasks based on hirarki_id
    if (props.hirarki_id == 1) {
      dispatch(hirarkiAction.setTugasUtamaIfId1(updatedTasks));
    } else {
      dispatch(hirarkiAction.setTugasUtamaIfId2(updatedTasks));
    }

    // Re-initialize the collapse view or any other UI logic after task addition
    configCollapseFirstReload();
  };

  const tambahDetailActivitas = async (hirarkiIndex1, hirarkiIndex2) => {
    addHistory(hirarki_wla);
    const updatedTasks = [...hirarki_wla];
    if (props.hirarki_id === 1) {
      dispatch(
        hirarkiAction.setDetailActivitasIfId1(updatedTasks, hirarkiIndex1)
      );
    } else {
      dispatch(
        hirarkiAction.setDetailActivitasIfId2(updatedTasks, hirarkiIndex1)
      );
    }
    configCollapseFirstReload();
  };
  const tambahUrutanProsess = (hirarkiIndex1, hirarkiIndex2, hirarkiIndex3) => {
    addHistory(hirarki_wla, hirarkiIndex1);
    dispatch(
      hirarkiAction.setUrutanProsess(hirarki_wla, hirarkiIndex1, hirarkiIndex2)
    );
    configCollapseFirstReload();
  };
  const showDeleteModal = (action) => {
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: `list`,
        modal_component: "confirm_delete",
        modal_size: 400,
        modal_type: "confirm",
        modal_data: {
          title: "Hirarki",
          action: () => action(),
          msg: `<p>Apakah anda yakin menghapus ? </p>`,
        },
        modal_action: "delete_hirarki",
      })
    );
  };
  const deleteTugasUtama = (index) => {
    if (is_edited) {
      const actionDel = () => {
        addHistory(hirarki_wla); // Save current state to history

        const updatedTasks = hirarki_wla.filter((_, i) => i !== index);
        dispatch(hirarkiAction.setHirarki(updatedTasks));
        dispatch(modalToggleReset());
      };
      showDeleteModal(actionDel);
    }
  };
  const deleteDetailAktivitas = (hirarkiIndex1, hirarkiIndex2) => {
    if (is_edited) {
      const actionDel = () => {
        // Save the current state before deletion for undo/redo functionality
        addHistory(hirarki_wla);

        // Remove the specific child at the given index
        hirarki_wla[hirarkiIndex1].child.splice(hirarkiIndex2, 1);

        // Dispatch the updated state to the store
        dispatch(hirarkiAction.setHirarki(hirarki_wla));
        dispatch(modalToggleReset());
      };
      // Show the delete confirmation modal
      showDeleteModal(actionDel);
    }
  };

  const deleteUruttanProsess = (hirarkiIndex1, hirarkiIndex2, hirarkiIndex3) => {
    if (is_edited) {
      const actionDel = () => {
        // Save the current state before deletion to enable undo/redo functionality
        addHistory(hirarki_wla);

        // Remove the child item at the specified index
        hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].child.splice(hirarkiIndex3, 1);

        // Dispatch the updated state to the store
        dispatch(hirarkiAction.setHirarki(hirarki_wla));

        // Reset the modal state
        dispatch(modalToggleReset());
      };
      // Show the delete confirmation modal
      showDeleteModal(actionDel);
    }
  };

  // console.log('eyoooo')
  const showTugasUtamaModal = (payload, text) => {
    if (is_edited) {
      setmodaltitle(text);
      settugasUtamaModal(payload);
    }
  };
  const showDetailAktivitasModal = (payload, text) => {
    if (is_edited) {
      setmodaltitle(text);
      setDetailTugasUtamaModal(payload);
    }
  };
  const showUrutanProsess = (payload, text) => {
    if (is_edited) {
      setmodaltitle(text);
      seturutanProsesModal(payload);
    }
  };
  const onChangeSub1 = (key, value, hirarkiIndex1, hirarkiIndex2) => {
    hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].detail[key] = value;
    dispatch(hirarkiAction.setHirarki(hirarki_wla));
  };
  const onChangeSub2 = (
    key,
    value,
    hirarkiIndex1,
    hirarkiIndex2,
    hirarkiIndex3
  ) => {
    hirarki_wla[hirarkiIndex1].child[hirarkiIndex2].child[hirarkiIndex3].detail[
      key
    ] = value;
    dispatch(hirarkiAction.setHirarki(hirarki_wla));
  };
  const renderIconEdit = () => {
    if (is_edited) {
      return Edit;
    } else {
      return EditDisable;
    }
  };
  const renderIconClose = () => {
    if (is_edited) {
      return close;
    } else {
      return CloseDisable;
    }
  };

  console.log(`hirarki_wla`, hirarki_wla);
  return (
    <div>
      {!showVideo ? (
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
              <div className="box-title-active" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Panduan Pengisian
                </p>
              </div>
              <div className="progress-bar-active" style={{ width: "75%" }}>
              </div>
            </div>
            <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
              <div className="box-title-inactive" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Review Jobdesc
                </p>
              </div>
              <div className="progress-bar-active" style={{ width: "75%" }}>
              </div>
            </div>
            <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
              <div className="box-title-inactive" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Form ABK
                </p>
              </div>
              <div className="progress-bar-active" style={{ width: "75%" }}>
              </div>
            </div>
            <div className="breadcrumb" style={{ width: "15%", display: "flex" }}>
              <div className="box-title-inactive" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Review Akhir
                </p>
              </div>
            </div>
          </div>
          <div className="card-content title" style={{ padding: 20 }}>
            <h2 style={{ marginTop: "0" }}>Panduan Pengisian</h2>
            <div className="card-content-video">
              <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>

                <div style={{ width: "50%" }}>

                  <p style={{ fontWeight: "bold" }}>
                    Selamat Datang di Aplikasi Pengisian Form Lembar Kerja ABK!
                  </p>

                  <p>
                    Terima kasih telah meluangkan waktu anda untuk mengakses dan menggunakan aplikasi ini.
                    <br></br>
                    <br></br>
                    Kami menjamin bahwa semua informasi yang anda berikan akan dijaga kerahasiaannya sesuai dengan ketentuan privasi dan peraturan yang berlaku di perusahaan kami.
                    <br></br>
                    <br></br>
                    Sebelum melanjutkan, kami menghimbau anda untuk terlebih dahulu <span style={{ fontWeight: "bold" }}>menyaksikan video panduan pengisian form</span>, terutama jika ini adalah kali pertama anda menggunakan sistem ini. Video ini akan memberikan panduan langkah demi langkah untuk mempermudah proses pengisian data.
                    <br></br>
                    <br></br>
                    Setelah anda siap, silakan klik tombol "Selanjutnya" di bagian kanan atas untuk melanjutkan ke halaman berikutnya dan mulai mengisi form.
                  </p>

                </div>

                <iframe style={{ width: "50%", height: "275px" }}
                  // src="https://www.youtube.com/embed/Dce8lnAZq34"
                  src="https://www.youtube.com/embed/ODqgZab7-nM?si=QDC6e0K7KemZjMkj"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <button className="button-next" style={{ width: "fit-content" }} onClick={handleNextVideo}>Selanjutnya</button>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      {!showData ? (
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
              <div className="box-title-done" style={{ width: "125%" }}>
                <p onClick={handlePanduan} style={{ padding: "1rem .5rem", margin: "0", cursor: "pointer" }}>
                  Panduan Pengisian
                </p>
              </div>
              <div className="progress-bar-done" style={{ width: "75%" }}>
              </div>
            </div>
            <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
              <div className="box-title-active" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Review Jobdesc
                </p>
              </div>
              <div className="progress-bar-active" style={{ width: "75%" }}>
              </div>
            </div>
            <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
              <div className="box-title-inactive" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Form ABK
                </p>
              </div>
              <div className="progress-bar-active" style={{ width: "75%" }}>
              </div>
            </div>
            <div className="breadcrumb" style={{ width: "15%", display: "flex" }}>
              <div className="box-title-inactive" style={{ width: "125%" }}>
                <p style={{ padding: "1rem .5rem", margin: "0" }}>
                  Review Akhir
                </p>
              </div>
            </div>
          </div>
          <div className="card-content" style={{ padding: 20 }}>


            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 style={{ margin: "0" }}>Review Job Desc</h2>
              <button className="undo-button" onClick={undo} disabled={!canUndo}>
                <img src="https://www.svgrepo.com/show/238330/undo.svg" alt="Undo" style={{ width: "20px", height: "20px" }} />
                Undo
              </button>
            </div>


            <p style={{ marginBottom: "0" }}>Panduan:</p>
            <p style={{ marginTop: "0" }}>Berikut adalah daftar Tanggung Jawab / Tugas Utama yang  posisi Anda.</p>
            <p style={{ margin: "0" }}> Apabila belum terisi, mohon lengkapi tugas utama anda</p>
            <ul style={{ margin: "0", paddingLeft: "1rem" }}>
              <li>
                Contoh: Menyusun rencana strategis organisasi yang terkait dengan SDM disusun secara efektif dan selaras dengan visi, misi, dan strategi bisnis
              </li>
            </ul>
            <p style={{ marginBottom: "0" }}>Apabila sudah terisi, periksa kembali apakah yang tertera sudah sesuai dengan pekerjaan Anda, silahkan edit :</p>
            <ul style={{ marginTop: "0", paddingLeft: "1rem" }}>
              <li>
                Edit / Ubah Penulisan Jobdesc dengan tombol [  <img style={{ margin: "-3px", cursor: "auto" }}
                  src={renderIconEdit()}
                  className="hirarki-icon"
                />  ] di sebelah kanan Jobdesc.
              </li>
              <li>
                Hapus Jobdesc  dengan tombol [ <img style={{ margin: "-3px", cursor: "auto" }}
                  src={renderIconClose()}
                  className="hirarki-icon"
                />  ] di sebelah kanan Jobdesc,
              </li>
            </ul>
            {hirarki_wla.map((hirarki1, hirarkiIndex1) => (
              <div className="hirarki-container" key={hirarkiIndex1}>
                {tugasUtamaModal[hirarkiIndex1] && (
                  <div
                    className="backdoor2"
                    onClick={() => showTugasUtamaModal({}, "")}
                  ></div>
                )}
                <div className="hirarki-top">
                  <div className="hirarki-text-padding div-flex div-align-start">
                    {hirarki1.mcb === false ? (
                      <p className="hirarki-number">{hirarki1.no}.</p>
                    ) : (
                      ""
                    )}
                    <div className="position-relative">
                      <p className="hirarki-text-item">{hirarki1.title}</p>
                      {tugasUtamaModal[hirarkiIndex1] && (
                        <div className="tugas-utama-modal">
                          <TextField
                            label="Deskripsi Tugas Utama"
                            variant="outlined"
                            type="text"
                            value={modaltitle}
                            size="small"
                            className={classes.textField}
                            onChange={(e) => setmodaltitle(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <Button
                            style={{ height: 35, width: 80 }}
                            onClick={() => onSaveDeskripsiTugasUtama(hirarkiIndex1)}
                            className="btn-remove-capital btn-rounded"
                            size="small"
                            variant="contained"
                            color="primary"
                          >
                            Simpan
                          </Button>
                        </div>
                      )}
                    </div>
                    <img
                      onClick={() =>
                        showTugasUtamaModal(
                          { [hirarkiIndex1]: !tugasUtamaModal[hirarkiIndex1] },
                          hirarki1.title
                        )
                      }
                      src={renderIconEdit()}
                      className="hirarki-icon"
                    />

                    {hirarkiIndex1 !== 0 && (
                      <img
                        onClick={() => deleteTugasUtama(hirarkiIndex1)}
                        src={renderIconClose()}
                        className="hirarki-icon"
                      />
                    )}
                  </div>
                </div>

                {hirarkiIndex1 === hirarki_wla.length - 1 &&
                  is_edited && (
                    <div style={{ width: "100%", marginTop: 20 }}>
                      <div
                        className="btn-tambah-tugas-utama"
                        onClick={tambahTugasUtama}
                      >
                        <p>Tambah Tugas Utama</p>
                      </div>
                    </div>
                  )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div> </div>
      )}
      <div>
        {!showResult ? (
          <div>
            {showData === true && showVideo === true ? (

              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
                  <div className="box-title-done" style={{ width: "125%" }}>
                    <p onClick={handlePanduan} style={{ padding: "1rem .5rem", margin: "0", cursor: "pointer" }}>
                      Panduan Pengisian
                    </p>
                  </div>
                  <div className="progress-bar-done" style={{ width: "75%" }}>
                  </div>
                </div>
                <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
                  <div className="box-title-done" style={{ width: "125%" }}>
                    <p onClick={handleReviewJob} style={{ padding: "1rem .5rem", margin: "0", cursor: "pointer" }}>
                      Review Jobdesc
                    </p>
                  </div>
                  <div className="progress-bar-done" style={{ width: "75%" }}>
                  </div>
                </div>
                <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
                  <div className="box-title-active" style={{ width: "125%" }}>
                    <p style={{ padding: "1rem .5rem", margin: "0" }}>
                      Form ABK
                    </p>
                  </div>
                  <div className="progress-bar-active" style={{ width: "75%" }}>
                  </div>
                </div>
                <div className="breadcrumb" style={{ width: "15%", display: "flex" }}>
                  <div className="box-title-inactive" style={{ width: "125%" }}>
                    <p style={{ padding: "1rem .5rem", margin: "0" }}>
                      Review Akhir
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )
            }

            <div className="card-content" style={{ padding: 20 }}>
              <div>
                {hirarki_wla.map((hirarki1, hirarkiIndex1) => (
                  <div style={{
                    display: hirarkiIndex1 === currentIndex ? "block" : "none",
                  }}>
                    <div style={{ marginBottom: "1rem" }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h2>
                          Form Analisa Beban Kerja ({currentIndex + 1}/{hirarki_wla.length})
                        </h2>
                        <button className="undo-button" onClick={undo} disabled={!canUndo}>
                          <img src="https://www.svgrepo.com/show/238330/undo.svg" alt="Undo" style={{ width: "20px", height: "20px" }} />
                          Undo
                        </button>
                      </div>
                      <p style={{ marginBottom: "0" }}>Panduan:</p>
                      <ul style={{ margin: "0", paddingLeft: "1rem" }}>
                        <li>
                          Rincikan Pekerjaan Anda melalui Aktivitas-Aktivitas yang biasa anda kerjakan untuk memenuhi Tanggung Jawab Pekerjaan
                        </li>
                        <li>
                          Dari Aktivitas tersebut, anda bisa meruntutkannya ke dalam proses-proses kerja yang bersifat teknis, sehingga dapat di petakan periode pelaksanaan, kuantitas, durasi pengerjaan, dan Jumlah pegawai yang terlibat.
                        </li>
                        <li>
                          Contoh :
                        </li>
                        <ul>
                          <li>
                            Aktivitas: Membuat Laporan Bulanan
                          </li>
                          <li>
                            Proses Kerja: Membuka Email, Mengumpulkan Data, Mengetik Laporan, Mereview Laporan, Meminta Approval Laporan.
                          </li>
                        </ul>
                        <li>
                          Definisi dari masing-masing pengisian dapat anda lihat dengan cara <span style={{ fontWeight: "bold" }}>mengarahkan pointer</span>  ke masing-masing kotak pengisian.
                        </li>
                        <li>
                          Pastikan Aktivitas dan Proses kerja yang anda tuliskan <span style={{ fontWeight: "bold" }}> tidak berulang</span> dengan pengisian di Tanggung Jawab Pekerjaan Lainnya.
                        </li>
                        <li>
                          Apabila pekerjaan memiliki catatan khusus, atau memiliki durasi di atas 240 menit, tuliskan catatan di kolom keterangan
                        </li>
                      </ul>
                    </div>
                    <div
                      className="hirarki-container"
                      key={hirarkiIndex1}
                      style={{
                        display: hirarkiIndex1 === currentIndex ? "block" : "none",
                      }}
                    >
                      {tugasUtamaModal[hirarkiIndex1] && (
                        <div
                          className="backdoor2"
                          onClick={() => showTugasUtamaModal({}, "")}
                        ></div>
                      )}
                      <div className="hirarki-top">
                        <div className="hirarki-text-padding div-flex div-align-start">
                          {hirarki1.mcb === false ? (
                            <p className="hirarki-number">{hirarki1.no}.</p>
                          ) : (
                            ""
                          )}
                          <div className="position-relative">
                            <p className="hirarki-text-item">{hirarki1.title}</p>
                            {tugasUtamaModal[hirarkiIndex1] && (
                              <div className="tugas-utama-modal">
                                <TextField
                                  label="Deskripsi Tugas Utama"
                                  variant="outlined"
                                  type="text"
                                  value={modaltitle}
                                  size="small"
                                  className={classes.textField}
                                  onChange={(e) => setmodaltitle(e.target.value)}
                                />
                                &nbsp;&nbsp;
                                <Button
                                  style={{ height: 35, width: 80 }}
                                  onClick={() => onSaveDeskripsiTugasUtama(hirarkiIndex1)}
                                  className="btn-remove-capital btn-rounded"
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                >
                                  Simpan
                                </Button>
                              </div>
                            )}
                          </div>
                          <img
                            onClick={() =>
                              showTugasUtamaModal(
                                { [hirarkiIndex1]: !tugasUtamaModal[hirarkiIndex1] },
                                hirarki1.title
                              )
                            }
                            src={renderIconEdit()}
                            className="hirarki-icon"
                          />
                          {hirarkiIndex1 !== 0 && (
                            <img
                              onClick={() => deleteTugasUtama(hirarkiIndex1)}
                              src={renderIconClose()}
                              className="hirarki-icon"
                            />
                          )}
                        </div>
                      </div>
                      {hirarki1.child.map((hirarki2, hirarkiIndex2) => (
                        <div key={hirarkiIndex2}>
                          {detailTugasUtamaModal[
                            parseInt(`${hirarkiIndex1}${hirarkiIndex2}`)
                          ] && (
                              <div
                                className="backdoor2"
                                onClick={() => showDetailAktivitasModal({}, "")}
                              ></div>
                            )}
                          <HirarkiItemSub
                            marginSize={1}
                            classes={classes}
                            onSaveDetailDeskripsiTugasUtama={
                              onSaveDetailDeskripsiTugasUtama
                            }
                            renderMarginSub={renderMarginSub}
                            setDetailTugasUtamaModal={setDetailTugasUtamaModal}
                            detailTugasUtamaModal={detailTugasUtamaModal}
                            urutanProsesModal={urutanProsesModal}
                            seturutanProsesModal={seturutanProsesModal}
                            hirarki1={hirarki1}
                            hirarki2={hirarki2}
                            hirarkiIndex1={hirarkiIndex1}
                            hirarkiIndex2={hirarkiIndex2}
                            setcollapse={setcollapse}
                            tambahDetailActivitas={tambahDetailActivitas}
                            collapse1={collapse1}
                            collapse2={collapse2}
                            setcollapse1={setcollapse1}
                            setcollapse2={setcollapse2}
                            deleteDetailAktivitas={deleteDetailAktivitas}
                            tambahUrutanProsess={tambahUrutanProsess}
                            deleteUruttanProsess={deleteUruttanProsess}
                            showDetailAktivitasModal={showDetailAktivitasModal}
                            modaltitle={modaltitle}
                            setmodaltitle={setmodaltitle}
                            showUrutanProsess={showUrutanProsess}
                            onSaveUrutanProssess={onSaveUrutanProssess}
                            periode={periode}
                            type={type}
                            onChangeSub1={onChangeSub1}
                            onChangeSub2={onChangeSub2}
                            is_edited={is_edited}
                            renderIconClose={renderIconClose}
                            renderIconEdit={renderIconEdit}
                          />
                        </div>
                      ))}
                      {/* {hirarkiIndex1 === hirarki_wla.length - 1 &&
                  is_edited &&
                  hirarki1.mcb === false && (
                    <div style={{ width: "100%", marginTop: 20 }}>
                      <div
                        className="btn-tambah-tugas-utama"
                        onClick={tambahTugasUtama}
                      >
                        <p>Tambah Tugas Utama</p>
                      </div>
                    </div>
                  )} */}
                    </div></div>
                ))}


                {currentIndex >= 0 ? (
                  <div>
                    <div style={{
                      display: showVideo ? "block" : "none", textAlign: "end"
                    }}>
                      <button
                        className="button-back"
                        onClick={handlePrevious}
                        // disabled={currentIndex === -1}
                        style={{ marginRight: "10px" }}
                      >
                        Kembali
                      </button>

                      <button
                        className="button-next"
                        onClick={handleNext}
                        disabled={isError || isErrorPegawai}
                        style={{
                          cursor: isError || isErrorPegawai ? 'not-allowed' : 'pointer',
                          opacity: isError || isErrorPegawai ? 0.5 : 1,
                        }}
                      >
                        Selanjutnya
                      </button>

                    </div>
                  </div>
                ) : (
                  <div>
                    <div style={{
                      display: showVideo ? "block" : "none", textAlign: "end"
                    }}>
                      <button
                        className="button-back"
                        onClick={handlePreviousVideo}
                        // disabled={currentIndex === -1}
                        style={{ marginRight: "10px" }}
                      >
                        Kembali
                      </button>
                      <button
                        className="button-next"
                        onClick={handleNext}
                      >
                        Selanjutnya
                      </button>

                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>
        ) : (
          <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
                <div className="box-title-done" style={{ width: "125%" }}>
                  <p onClick={handlePanduan} style={{ padding: "1rem .5rem", margin: "0", cursor: "pointer" }}>
                    Panduan Pengisian
                  </p>
                </div>
                <div className="progress-bar-done" style={{ width: "75%" }}>
                </div>
              </div>
              <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
                <div className="box-title-done" style={{ width: "125%" }}>
                  <p onClick={handleReviewJob} style={{ padding: "1rem .5rem", margin: "0", cursor: "pointer" }}>
                    Review Jobdesc
                  </p>
                </div>
                <div className="progress-bar-done" style={{ width: "75%" }}>
                </div>
              </div>
              <div className="breadcrumb" style={{ width: "25%", display: "flex" }}>
                <div className="box-title-done" style={{ width: "125%" }}>
                  <p onClick={handleAbk} style={{ padding: "1rem .5rem", margin: "0", cursor: "pointer" }}>
                    Form ABK
                  </p>
                </div>
                <div className="progress-bar-done" style={{ width: "75%" }}>
                </div>
              </div>
              <div className="breadcrumb" style={{ width: "15%", display: "flex" }}>
                <div className="box-title-active" style={{ width: "125%" }}>
                  <p style={{ padding: "1rem .5rem", margin: "0" }}>
                    Review Akhir
                  </p>
                </div>
              </div>
            </div>
            <div className="card-content" style={{ padding: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>

                <h2>Review Akhir / Finalisasi</h2>
                <button className="undo-button" onClick={undo} disabled={!canUndo}>
                  <img src="https://www.svgrepo.com/show/238330/undo.svg" alt="Undo" style={{ width: "20px", height: "20px" }} />
                  Undo
                </button>
              </div>
              <div>
                {hirarki_wla.map((hirarki1, hirarkiIndex1) => (
                  <div className="hirarki-container" key={hirarkiIndex1}>
                    {tugasUtamaModal[hirarkiIndex1] && (
                      <div
                        className="backdoor2"
                        onClick={() => showTugasUtamaModal({}, "")}
                      ></div>
                    )}
                    <div className="hirarki-top">
                      <div className="hirarki-text-padding div-flex div-align-start">
                        {hirarki1.mcb === false ? (
                          <p className="hirarki-number">{hirarki1.no}.</p>
                        ) : (
                          ""
                        )}
                        <div className="position-relative">
                          <p className="hirarki-text-item">{hirarki1.title}</p>
                          {tugasUtamaModal[hirarkiIndex1] && (
                            <div className="tugas-utama-modal">
                              <TextField
                                label="Deskripsi Tugas Utama"
                                variant="outlined"
                                type="text"
                                value={modaltitle}
                                size="small"
                                className={classes.textField}
                                onChange={(e) => setmodaltitle(e.target.value)}
                              />
                              &nbsp;&nbsp;
                              <Button
                                style={{ height: 35, width: 80 }}
                                onClick={() => onSaveDeskripsiTugasUtama(hirarkiIndex1)}
                                className="btn-remove-capital btn-rounded"
                                size="small"
                                variant="contained"
                                color="primary"
                              >
                                Simpan
                              </Button>
                            </div>
                          )}
                        </div>
                        <img
                          onClick={() =>
                            showTugasUtamaModal(
                              { [hirarkiIndex1]: !tugasUtamaModal[hirarkiIndex1] },
                              hirarki1.title
                            )
                          }
                          src={renderIconEdit()}
                          className="hirarki-icon"
                        />

                        {hirarkiIndex1 !== 0 && (
                          <img
                            onClick={() => deleteTugasUtama(hirarkiIndex1)}
                            src={renderIconClose()}
                            className="hirarki-icon"
                          />
                        )}
                      </div>
                    </div>
                    {hirarki1.child.map((hirarki2, hirarkiIndex2) => (
                      <div key={hirarkiIndex2}>
                        {detailTugasUtamaModal[
                          parseInt(`${hirarkiIndex1}${hirarkiIndex2}`)
                        ] && (
                            <div
                              className="backdoor2"
                              onClick={() => showDetailAktivitasModal({}, "")}
                            ></div>
                          )}
                        <HirarkiItemSub
                          marginSize={1}
                          classes={classes}
                          onSaveDetailDeskripsiTugasUtama={
                            onSaveDetailDeskripsiTugasUtama
                          }
                          renderMarginSub={renderMarginSub}
                          setDetailTugasUtamaModal={setDetailTugasUtamaModal}
                          detailTugasUtamaModal={detailTugasUtamaModal}
                          urutanProsesModal={urutanProsesModal}
                          seturutanProsesModal={seturutanProsesModal}
                          hirarki1={hirarki1}
                          hirarki2={hirarki2}
                          hirarkiIndex1={hirarkiIndex1}
                          hirarkiIndex2={hirarkiIndex2}
                          setcollapse={setcollapse}
                          tambahDetailActivitas={tambahDetailActivitas}
                          collapse1={collapse1}
                          collapse2={collapse2}
                          setcollapse1={setcollapse1}
                          setcollapse2={setcollapse2}
                          deleteDetailAktivitas={deleteDetailAktivitas}
                          tambahUrutanProsess={tambahUrutanProsess}
                          deleteUruttanProsess={deleteUruttanProsess}
                          showDetailAktivitasModal={showDetailAktivitasModal}
                          modaltitle={modaltitle}
                          setmodaltitle={setmodaltitle}
                          showUrutanProsess={showUrutanProsess}
                          onSaveUrutanProssess={onSaveUrutanProssess}
                          periode={periode}
                          type={type}
                          onChangeSub1={onChangeSub1}
                          onChangeSub2={onChangeSub2}
                          is_edited={is_edited}
                          renderIconClose={renderIconClose}
                          renderIconEdit={renderIconEdit}
                        />
                      </div>
                    ))}
                    {hirarkiIndex1 === hirarki_wla.length - 1 &&
                      is_edited && (
                        <div style={{ width: "100%", marginTop: 20 }}>
                          <div
                            className="btn-tambah-tugas-utama"
                            onClick={tambahTugasUtama}
                          >
                            <p>Tambah Tugas Utama</p>
                          </div>
                        </div>
                      )}
                  </div>
                ))}
              </div>
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={checked} // Bind the state to the checkbox
                    onChange={handleCheckboxChange} // Update state on change
                  />
                  Saya sudah memeriksa kembali pengisian lembar kerja ABK saya. Saya
                  menjamin bahwa pengisian diatas sudah benar dan sesuai dengan apa yang
                  biasa saya kerjakan selama periode analisa beban kerja yang ditetapkan.
                </label>
              </div>

              <div style={{ textAlign: "end" }}>
                <button
                  className="button-back"
                  onClick={handlePreviousFirst}
                  disabled={checked}
                  style={{ marginRight: "10px" }}
                >
                  Kembali
                </button>
              </div>

            </div>
          </div>
        )}
      </div>
    </div>
  );
}
